import { Card, Grid, Typography, } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BlsGridTitle from '../components/BlsGridTitle';
import { BlsButton, BlsInput, useBlsInput, useBlsSearchInput } from '../components/ui-common';
import ParameterConstants from '../constants/ParameterConstants';
import belsoftCore from '../core/index.ts';
import AppSettings from '../webConfig';

function PasswordChange() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const txtUserCode = useBlsInput({ label: "Kullanıcı Kodu:", disabled: true });
    const txtUserName = useBlsSearchInput({ label: "Kullanıcı Adı:", disabled: true });
    const txtUserSurname = useBlsInput({ label: "Kullanıcı Soyadı:", disabled: true });
    const txtUserEmail = useBlsInput({ label: "E-Posta:", disabled: true });
    const txtUserPidNo = useBlsInput({ label: "TC Kimlik No:", disabled: true });
    const txtMobilePhoneNumber = useBlsSearchInput({ label: "Cep Telefonu:", disabled: true });

    const txtUserBranches = useBlsInput({ label: "Şube:", disabled: true });
    const txtUserDepartments = useBlsInput({ label: "Birim:", disabled: true });
    const txtUserTitles = useBlsInput({ label: "Ünvan:", disabled: true });
    const txtUserRoles = useBlsSearchInput({ label: "Rol:", disabled: true });
    const txtPassword = useBlsInput({ label: "Şifre:" });
    const txtPasswordAgain = useBlsInput({ label: "Şifre Tekrar:" });

    useEffect(() => {
        async function pageLoad() {
            try {
                setLoading(true);

                let user = await belsoftCore.services.tapuService.getUser()
                let userDetail = user.UserDetail
                let activeBranches = (await belsoftCore.services.tapuService.retrieveBranches())[0];
                let activeDepartments = await belsoftCore.services.tapuService.getAllDepartments();
                let activeRoles = (await belsoftCore.services.tapuService.retrieveRoles())[0];

                let userBranch = activeBranches.find(t => t.BranchCode === userDetail.BranchCode)// BranchCode
                let userDepartment = activeDepartments.find(t => t.DepartmentCode === userDetail.DepartmentCode)
                let userRole = activeRoles.find(t => t.RoleCode === userDetail.RoleCode)

                txtUserCode.setValue(user.UserName)
                txtUserName.setValue(userDetail.Registry.RegistryInfo.Name)
                txtUserSurname.setValue(userDetail.Registry.RegistryInfo.SurName)
                txtUserEmail.setValue(userDetail.Registry.RegistryInfo.Email)
                txtUserPidNo.setValue(userDetail.Registry.RegistryInfo.IdentityNumber)
                txtMobilePhoneNumber.setValue(userDetail.Registry.RegistryInfo.GsmNumber)
                txtUserBranches.setValue(userBranch?.BranchName)
                txtUserDepartments.setValue(userDepartment?.DepartmentName)
                txtUserTitles.setValue(userDetail.Title.TitleName)
                txtUserRoles.setValue(userRole?.RoleName)


                setLoading(false);
            } catch (e) {
                setLoading(false);
                return;
            }
        }
        pageLoad();
    }, []);


    const goToHomePage = () => {
        navigate(ParameterConstants.URL_EXTENSION);
    }
    const changePassword = async () => {
        try {
            if (txtPasswordAgain.value !== "") {
                if ((txtPassword.value).trim() !== (txtPasswordAgain.value).trim()) {
                    toast.warning('Şifre ve Şifre tekrarı aynı olmak zorundadır.', { position: "top-right", autoClose: 4000, theme: 'dark', });
                    return false;
                }
                setLoading(true)
                await belsoftCore.services.tapuService.changePassword(txtPasswordAgain.value, AppSettings.ApplicationName, false, AppSettings.machineKey.validationKey)
                toast.success('Şifreniz başarıyla değiştirildi.', { position: "top-right", autoClose: 4000, theme: 'dark', });
                txtPasswordAgain.setValue('')
                txtPassword.setValue('')
                setLoading(false)
            }
            else {
                toast.warning('Lütfen şifre alanlarını boş bırakmayın.', { position: "top-right", autoClose: 4000, theme: 'dark', });
            }
        }
        catch (e) {
            setLoading(false);
            return;
        }

    }

    return (

        <div style={{
            width: '100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            resizeMode: 'stretch',
            flex: 1,
            background: '#1A2038',
            height: '100vh'
        }} className="app">

            <Card style={{ width: '36%', position: 'absolute', left: '32%', top: '32%', borderRadius: 12, padding: "30px", }}>
                <Grid container>
                    <Typography style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>Şifre Değiştirme</Typography>
                    <BlsGridTitle title="Kullanıcı Profili" width="30%" >
                        <Grid item xs={12} container>
                            <Grid item xs={6} style={{ paddingBottom: ".5%" }}>
                                <div style={{ marginTop: "4%" }} />
                                <BlsInput inputState={txtUserCode} />
                                <BlsInput inputState={txtUserName} />
                                <BlsInput inputState={txtUserSurname} />
                                <BlsInput inputState={txtUserEmail} />
                                <BlsInput inputState={txtUserPidNo} />
                                <BlsInput inputState={txtMobilePhoneNumber} />
                            </Grid>
                            <Grid item xs={6} style={{ paddingBottom: ".5%" }} >
                                <div style={{ marginTop: "4%" }} />
                                <BlsInput inputState={txtUserBranches} />
                                <BlsInput inputState={txtUserDepartments} />
                                <BlsInput inputState={txtUserTitles} />
                                <BlsInput inputState={txtUserRoles} />
                                <BlsInput inputState={txtPassword} type='password' />
                                <BlsInput inputState={txtPasswordAgain} type='password' />

                                <BlsButton type="home" buttonStyle={{ width: '45%', marginTop: '4%' }} onClick={goToHomePage}>Anasayfaya Dön</BlsButton>
                                <BlsButton type="update" buttonStyle={{ width: '45%', marginTop: '4%' }} onClick={changePassword}>Güncelle</BlsButton>

                            </Grid>
                        </Grid>
                    </BlsGridTitle>
                </Grid>
            </Card>
            <ToastContainer />
        </div>
    )
}

export default PasswordChange;


